import React from 'react';
import { useHistory } from 'react-router-dom';
import { DISCOUNTS_VISIBLE } from '../../../config/featureFlags';
import { hapticTick } from '../../../_utils/haptics';
import { useLiveCodes, canManageCodes } from '../discountStore';
import { dateSaid, headlineOf } from '../data/codes';

// Catalogue's door to discount codes: on a service, the live codes that
// cover it, and "Make a code for this service" (Marketing › Discounts with
// the editor open on it).
const covers = (code, serviceId, categoryId) => {
  const s = code.scope || {};
  if (s.services !== 'some') return true;
  return (s.serviceIds || []).map(String).includes(String(serviceId))
    || (!!categoryId && (s.categoryIds || []).map(String).includes(String(categoryId)));
};

export default function ServiceCodes({ serviceId, serviceName, categoryId }) {
  const history = useHistory();
  const { codes, loaded } = useLiveCodes();
  if (!DISCOUNTS_VISIBLE || !serviceId || !canManageCodes()) return null;
  const on = codes.filter((c) => covers(c, serviceId, categoryId));
  return (
    <div className="sep-section">
      <p className="sep-section-label">Discount codes</p>
      {!loaded ? null : on.length ? (
        <div style={{ display: 'grid', gap: 8, marginBottom: 14 }}>
          {on.map((c) => (
            <div key={c.id} style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', fontSize: 13.5, color: '#29282D' }}>
              <span style={{ fontFamily: 'ui-monospace, "SF Mono", Menlo, monospace', fontWeight: 700, fontSize: 12.5, letterSpacing: '0.05em', border: '1.5px dashed #c9c9d1', borderRadius: 7, padding: '4px 8px', background: '#fff' }}>{c.code}</span>
              <span style={{ minWidth: 0 }}>{headlineOf(c)}{c.endsOn ? `, book by ${dateSaid(c.endsOn)}` : ''}</span>
            </div>
          ))}
        </div>
      ) : (
        <p style={{ fontSize: 13, color: '#6e6e73', margin: '0 0 14px', lineHeight: 1.5 }}>No live codes cover this service.</p>
      )}
      <button
        type="button"
        onClick={() => { hapticTick(); history.push('/marketing-discounts', { newFor: { id: String(serviceId), name: serviceName || '' } }); }}
        style={{ height: 38, padding: '0 14px', borderRadius: 10, border: '1px solid #e5e5e5', background: '#fff', fontFamily: 'inherit', fontSize: 13.5, fontWeight: 600, color: '#29282D', cursor: 'pointer' }}
      >
        Make a code for this service
      </button>
    </div>
  );
}
